









import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GColorpicker',
  props: {
    value: {
      type: String as PropType<string>,
      default: null,
    },
  },
  computed: {
    innerValue: {
      get(): string|null {
        return this.value;
      },
      set(value: string): void {
        this.$emit('change', value);
      },
    },
  },
});
